export function documentReady () {
  return new Promise((resolve, reject) => {
    if (
      document.readyState === 'complete' ||
      (document.readyState !== 'loading' && !document.documentElement.doScroll)
    ) {
      resolve()
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        resolve()
      })
    }
  })
}
